import React from 'react';
import './error.layout.style.scss';
export const ErrorLayout = props => {
    const { children } = props;
    return (React.createElement("div", { className: 'row' },
        React.createElement("div", { className: 'd-flex align-items-center justify-content-center mb-3 mb-md-0 col-12 col-md-5 col-lg-4 col-xl-3' },
            React.createElement("i", { className: 'mdi mdi-alert-circle-outline responsive-error-icon-font-size text-secondary' })),
        React.createElement("div", { className: 'col-12 col-md-7 col-lg-8 col-xl-9 d-flex align-items-center justify-content-center justify-content-md-start' },
            React.createElement("div", { className: 'd-flex flex-column' }, children))));
};
export const ErrorContentLayout = props => {
    const { children } = props;
    return (React.createElement("div", { className: 'container' },
        React.createElement("div", { className: 'card border-0 rounded-lg p-4 error-layout-shadow' },
            React.createElement(ErrorLayout, null, children))));
};
